import React from "react";
import Api from "../../../../services/ServiceApi";
import { Collapse } from "antd";

const { Panel } = Collapse;
// const sites = [
//   { key: "Site ID", value: "" },
//   { key: "Site Name", value: "" },
// ];
export default function SiteAccess({ title, Jobdata }) {
  const { result_site_access } = Jobdata;
  return (
    <>
      <Collapse
        className="container"
        expandIconPosition="right"
        defaultActiveKey={["1"]}
      >
        <Panel
          header={
            <>
              <img
                src={Api.absoluteUrl(`/icon/bbtec/body/Site_Access.png`)}
                alt={title}
                title={title}
              />
              <h4>{title}</h4>
            </>
          }
          key="1"
        >
          <div className="row">
            <span className="col col-4 content-label">{`Office Time`}</span>
            <span className="col col-8 content-text">
              {result_site_access && result_site_access.length > 0
                ? result_site_access[0].siteAccess || `-`
                : `-`}
            </span>
          </div>
          <div className="row">
            <span className="col col-4 content-label">{`Remark`}</span>
            <span className="col col-8 content-text">
              {result_site_access && result_site_access.length > 0
                ? result_site_access[0].remark || `-`
                : `-`}
            </span>
          </div>
        </Panel>
      </Collapse>
    </>
  );
}
